export class Submit {
  static readonly type = 'Submit';
}
